/**
 * Verrou de publication d'un site.
 *
 * Quand la règle générale « validation admin avant publication » est active,
 * un site ne part en ligne qu'une fois validé par un administrateur. Un
 * administrateur publie toujours (c'est lui qui valide).
 *
 * Confort d'interface uniquement : le serveur refuse la publication de son
 * côté (403 `web_validation_required`).
 */

export const AWAITING_VALIDATION_MESSAGE = 'Votre société exige qu\'un administrateur relise et valide un site avant sa mise en ligne. Ce site ne l\'est pas encore : prévenez un administrateur, le bouton Publier s\'activera dès sa validation.';

export function resolvePublishGate({ ruleEnabled, validated, canValidate }) {
  if (!ruleEnabled || validated || canValidate) {
    return { canPublish: true, reason: 'ok' };
  }
  return { canPublish: false, reason: 'awaiting_validation' };
}

/** Deux états de validation décrivent-ils la même chose ? Sert à ne pas
 *  déclencher de rendu quand une relecture ne change rien. */
export function isSameValidation(a, b) {
  return !!a?.validated === !!b?.validated
    && (a?.validatedAt || null) === (b?.validatedAt || null)
    && (a?.validatedBy?.id ?? null) === (b?.validatedBy?.id ?? null);
}

/** Normalise la charge `web_validation` du serveur (absente tant que le back
 *  n'est pas livré → site considéré non validé). */
export function normalizeWebValidation(payload) {
  return {
    validated: !!payload?.validated,
    validatedAt: payload?.validated_at || null,
    validatedBy: payload?.validated_by
      ? { id: payload.validated_by.id, name: payload.validated_by.name }
      : null,
  };
}
